<script>
export default {
  name: "tracker-aside",
  data() {
    return {
      lbl_number_of_commitments: window.Drupal.t('Number of Youth Climate Actions Pledged'),
      filter_instruction: window.Drupal.t('Filter search results below or select a region on the map for more information: ')
    }
  }
};
</script>

<template>
  <aside id="sidebar">
    <div class="header-container">
      <h3>{{ this.lbl_number_of_commitments }}</h3>
    </div>
    <div id="map-data">
      <p>{{ this.filter_instruction }}</p>
      <ul id="action-commitments"></ul>
    </div>
  </aside>
</template>

<style>
#sidebar,
#map {
  width: 100%;
  height: 100%;
}

#map-data {
  display: none;
  padding: 1rem 1.2rem;
}

.header-container {
  display: block;
  padding: 1rem 1.2rem;
  background-color: var(--primary-green);
}
</style>
